<ion-card *ngIf="crmContact$ | async as contact" (click)="chatContact()" class="qvs-request-contact">
  <ion-card-content class="qvs-request-contact__content">
    <qvs-svg-icon class="qvs-request-contact__content__icon" [src]="'assets/images/chatbubbles-outline.svg'"></qvs-svg-icon>
    <div class="qvs-request-contact__content__text">
      {{ text }}
    </div>
    <qvs-svg-icon class="qvs-request-contact__content__arrow" [src]="'assets/images/arrow-primary-4.svg'"></qvs-svg-icon>
  </ion-card-content>
</ion-card>
